<template>
  <div class="container">
    <div class="complaint-main">
      <div class="goods-info">
        <div class="img"><img :src="dataInfo.PicUrl" alt="" /></div>
        <div class="title">
          <!-- <span class="platform-tag pdd" v-if="platformType === 2">拼多多</span>
          <span class="platform-tag tm" v-if="platformType === 1">天猫</span> -->
          <plat-formLogo :shopType="dataInfo.ShopType"></plat-formLogo>
          <template>{{ dataInfo.TitleShort || '----' }}</template>
        </div>
      </div>
      <!-- 评价 -->
      <div class="complaint-select">
        <div @click="switchSelect(0)" class="complaint-select-item" :class="{ active: currentActive === 0 }">
          <p class="icon iconfont icon-bugaoxing"></p>
          <p>极度不满</p>
        </div>
        <div @click="switchSelect(1)" class="complaint-select-item" :class="{ active: currentActive === 1 }">
          <p class="icon iconfont icon-kuliancopy"></p>
          <p>不满意</p>
        </div>
        <div @click="switchSelect(2)" class="complaint-select-item" :class="{ active: currentActive === 2 }">
          <p class="icon iconfont icon-xiao"></p>
          <p>一般</p>
        </div>
      </div>
      <!-- 输入投诉内容 -->
      <div class="complaint-input">
        <textarea
          v-model="complaintInputText"
          name="complaintArea"
          rows="6"
          maxlength="1000"
          @blur="textareaBlur"
          :placeholder="`说说你对商品不满意的地方，如情况属实，我们将给你补偿免单卡。为避免账号在搜货购物受到影响，请勿到${PLATFORM_TYPE_DETAIL[platformType].collectively}进行差评，切记~`"
        >
        </textarea>
      </div>
    </div>
    <!-- 图片上传 -->
    <div class="order_from">
      <div class="b_black err-b fs-26">
        <span>上传投诉相关凭证截图，有助于我们跟商家理论（选填）</span>
        <span class="iconfont icon-sanjiaoxing"></span>
      </div>
      <!-- upload -->
      <div class="weui-cells sub-upload">
        <div class="weui-cell">
          <div class="weui-uploader">
            <div class="weui-uploader__bd">
              <div class="weui-uploader__files">
                <template v-for="(item, index) in uploadImgSrcArrays">
                  <div
                    v-if="item.isUploading || item.isUploadFail || item.uploadImgSrc"
                    class="weui-uploader__file"
                    :class="[item.isUploading || item.isUploadFail ? 'weui-uploader__file_status' : '']"
                    :key="item.lastModified"
                  >
                    <div @click="previewImage(index)">
                      <img v-if="item.uploadImgSrc" :src="item.uploadImgSrc" class="weui-uploader__img" />
                    </div>
                    <i v-if="item.uploadImgSrc" class="imgclose iconfont icon-LogonClosed" @click="deleteUploadImg(index)"> </i>
                    <div v-if="item.isUploading" class="weui-uploader__file-content">{{ item.uploadingProgress }}%</div>
                    <div v-if="item.isUploadFail" class="weui-uploader__file-content">
                      <i>上传失败</i>
                    </div>
                  </div>
                </template>
                <div class="weui-uploader__input-box" v-if="uploadImgSrcArrays.length < 3">
                  <p><i class="iconfont icon-shangchuanzhaopian"></i></p>
                  <p>上传凭证</p>
                  <p>(最多三张)</p>
                  <div class="weui-uploader__input">
                    <input type="file" class="upload-input" accept="image/*" multiple @change="selectImgChange($event)" />
                  </div>
                </div>
                <!-- list end -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-btn b_fff flex">
        <div>
          <mt-button type="default" @click="goBack">返回</mt-button>
        </div>
        <div class="btn-margin">
          <mt-button type="danger" @click="formSubmit" :disabled="btnLoading || btnDisabled">提交投诉</mt-button>
        </div>
      </div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_BASE_URL } from '@/config'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { UpaiyunUploadInfoGet } from '@/api/order'
import { GetSimpleProductInfo, SubmitComplain } from '@/api/complain'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
export default {
  name: 'ComplaintPage',
  data() {
    return {
      productId: '',
      taskId: '',
      dataInfo: {},
      platformType: 0, // 2：拼多多
      complaintInputText: '',
      currentActive: null,
      // isUploading: false,
      // isUploadFail: false,
      // uploadingProgress: 0,
      // uploadImgSrc: '',
      uploadImgSrcArrays: [], // 图片上传对象数组，控制图片上传展示
      uploadUserInfo: {}, // 获取上传图片信息
      allImgUploaded: false, // 所有图片是否上传完成
      previewDialogShow: false,
      previewImgSrc: '',
      showRootPath: IMG_BASE_URL,
      btnLoading: false,
      btnDisabled: true
    }
  },
  mounted() {
    this.productId = this.$route.query.productId
    this.taskId = this.$route.query.taskId
    if (this.productId) {
      this.fetchData()
      this.fetchUploadInfo()
    } else {
      Toast('无商品id')
      this.$router.go(-1)
    }
  },
  components: {
    PreviewDialog
  },
  watch: {
    complaintInputText() {
      this.complaintInputText && this.currentActive !== null ? (this.btnDisabled = false) : (this.btnDisabled = true)
      if (this.complaintInputText.length > 1000) {
        this.complaintInputText = this.complaintInputText.substring(0, 1000)
      }
    }
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      GetSimpleProductInfo({ productId: this.productId })
        .then((res) => {
          Indicator.close()
          this.dataInfo = res.Data
          this.platformType = this.$utils.shopTypeNumChangeToPlatformType(this.dataInfo.ShopType)
          this.dataInfo.ShopType = this.$utils.shopTypeNumChangeToText(this.dataInfo.ShopType)
        })
        .catch((err) => {
          Indicator.close()
          Toast(err.ErrMsg)
        })
    },
    // 获取上传图片信息
    fetchUploadInfo() {
      UpaiyunUploadInfoGet().then((res) => {
        this.uploadUserInfo.uploadUrl = res.UploadUrl
        this.uploadUserInfo.loginName = res.LoginName
        this.uploadUserInfo.password = res.Screct
      })
    },
    // 图片上传
    selectImgChange(event) {
      let files = event.target.files
      let filesLength = files.length
      if (filesLength > 3 || this.uploadImgSrcArrays.length > 3 || filesLength + this.uploadImgSrcArrays.length > 3) {
        Toast('最多上传3张图片')
        return
      }
      this.allImgUploaded = true
      let promisesArray = []
      for (let i = 0; i < filesLength; i++) {
        let promise = this.fileUpload(files[i], i)
        promisesArray.push(promise)
      }
      axios.all(promisesArray).then(
        axios.spread((acct, perms) => {
          // document.querySelector('.upload-input').value = ''
          this.allImgUploaded = false
        })
      )
    },
    /**
     * @method fileUpload 图片上传
     * @param file 文件
     * @param index 文件数组索引
     * @return Promise
     */
    fileUpload(file, index) {
      if (!file) return Promise.resolve()
      let curOptionIndex = index
      if (this.uploadImgSrcArrays.length > 0) {
        curOptionIndex = this.uploadImgSrcArrays.length
      }
      if (this.uploadImgSrcArrays.length < 3) {
        this.uploadImgSrcArrays.push({
          uploadImgSrc: '',
          isUploading: false,
          isUploadFail: false,
          uploadingProgress: 0
        })
      }
      let uploadObj = this.uploadImgSrcArrays[curOptionIndex]
      let limitSize = 1024 * 1024 * 10
      if (file.size > limitSize) {
        Toast('图片大小不能超过10M')
        uploadObj.isUploadFail = true
        return Promise.resolve()
      }
      uploadObj.uploadImgSrc = window.URL.createObjectURL(file)
      let rootPath = this.showRootPath
      let data = new FormData()
      data.append('complaintPageUpload', file)
      return axios({
        method: 'post',
        url: this.uploadUserInfo.uploadUrl,
        params: {
          loginName: this.uploadUserInfo.loginName,
          secret: this.uploadUserInfo.password
        },
        data: data,
        timeout: 60000,
        onUploadProgress: (progressEvent) => {
          // 显示相应的上传进度
          let percent = (progressEvent.loaded / progressEvent.total) * 100
          uploadObj.uploadingProgress = parseInt(percent)
          uploadObj.isUploading = true
          uploadObj.isUploadFail = false
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.StatusCode === 200) {
            // 上传成功，展示图片，隐藏进度条
            uploadObj.uploadImgSrc = rootPath + res.data.Message
            uploadObj.isUploading = false
            uploadObj.isUploadFail = false
          } else {
            Toast(res.Message)
            uploadObj.uploadingProgress = 0
            uploadObj.uploadImgSrc = ''
            uploadObj.isUploading = false
            uploadObj.isUploadFail = true
          }
        })
        .catch(() => {
          Toast(`第${curOptionIndex + 1}张图片上传失败！请重新上传`)
          uploadObj.uploadingProgress = 0
          uploadObj.uploadImgSrc = ''
          uploadObj.isUploading = false
          uploadObj.isUploadFail = true
        })
    },
    deleteUploadImg(index) {
      this.uploadImgSrcArrays.splice(index, 1)
    },
    previewImage(index) {
      this.previewImgSrc = this.uploadImgSrcArrays[index].uploadImgSrc
      this.previewDialogShow = true
    },
    // 满意度
    switchSelect(val) {
      this.currentActive = val
      if (this.complaintInputText) this.btnDisabled = false
    },
    textareaBlur() {
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    },
    goBack() {
      this.$router.go(-1)
    },
    formSubmit() {
      if (this.currentActive === null) {
        this.btnDisabled = true
        Toast('请选择满意度')
        return
      }
      if (!this.complaintInputText) {
        this.btnDisabled = true
        Toast('请输入投诉说明')
        return
      }
      if (this.allImgUploaded) {
        Toast('图片上传中...')
        return
      }
      if (!this.taskId) {
        Toast('无任务id')
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.btnLoading = true
      let uploadImgsStr = ''
      uploadImgsStr = this.uploadImgSrcArrays
        .map((item) => {
          return item.uploadImgSrc
        })
        .join(',')
      SubmitComplain({
        TaskId: this.taskId,
        ComplainType: this.currentActive,
        ComplainRemark: this.complaintInputText,
        ComplainPic: uploadImgsStr
      })
        .then((res) => {
          this.btnLoading = false
          Indicator.close()
          MessageBox({
            title: '提示',
            message: `我们已收到你的投诉，平台客服会尽快核实情况。请勿到${this.PLATFORM_TYPE_DETAIL[this.platformType].collectively}进行差评哦~`,
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            confirmButtonText: '好的'
          }).then((action) => {
            if (action === 'confirm') {
              this.$router.replace({
                name: 'order',
                query: {
                  tabIndex: 3,
                  flag: true
                }
              })
            }
          })
        })
        .catch((err) => {
          this.btnLoading = false
          Indicator.close()
          Toast(err.ErrMsg)
        })
    }
  }
}
</script>

<style scoped>
.complaint-main {
  width: 100%;
  background: #fff;
  padding: 0 2% 3%;
  box-sizing: border-box;
}
.goods-info {
  height: 80px;
  display: flex;
  padding: 10px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.goods-info .img {
  height: 60px;
  width: 60px;
  margin-right: 10px;
  flex-shrink: 0;
}
.goods-info .title {
  height: 100%;
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
}
.goods-info .img > img {
  height: 100%;
  width: 100%;
  display: block;
  border-radius: 5px;
}
.complaint-select {
  display: flex;
  align-items: center;
  padding: 0 20px;
  color: #999;
  height: 100px;
}
.complaint-select-item {
  flex-grow: 1;
  flex-shrink: 0;
  text-align: center;
}
.complaint-select-item .icon {
  font-size: 35px;
  padding-left: 5px;
}
.complaint-select-item p:last-child {
  margin-top: 5px;
}
.complaint-select-item:nth-child(1).active {
  color: #ff0000;
}
.complaint-select-item:nth-child(2).active {
  color: #ff9900;
}
.complaint-select-item:nth-child(3).active {
  color: #3e9fff;
}
.complaint-input {
  padding: 0 5px;
}
.complaint-input > textarea {
  border-style: none;
  width: 100%;
  background: #f2f1f1;
  border-radius: 5px;
  padding: 12px 10px;
  box-sizing: border-box;
  resize: none;
}
textarea:focus {
  border-color: #fff;
  outline: 0;
}
.b_black {
  background: #2c2c2c;
  color: #fff;
}
.err-b {
  position: relative;
  z-index: 99;
  width: 100%;
  padding: 10px 10px;
  margin-top: 3%;
  box-sizing: border-box;
}
.err-b .iconfont {
  position: absolute;
  font-size: 18px;
  left: 22px;
  color: #2c2c2c;
  bottom: -13px;
}
.order-btn {
  justify-content: flex-end;
  position: fixed;
  align-items: center;
  bottom: 0;
  height: 65px;
  line-height: 65px;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  overflow: hidden;
}
.order-btn button {
  font-size: 14px;
  padding: 0px 15px;
  height: 2.5em;
  line-height: 2.5em;
  margin: 0;
}
.order-btn .btn-margin {
  margin: 0 15px;
}
/**
    upload
   */
.sub-upload {
  margin: -2px 0 5.3em 0;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.upload-input {
  height: 100%;
  width: 100%;
  display: block;
}
.weui-cell {
  padding: 10px 15px;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 2.5em;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: hidden;
}
.weui-uploader__input-box {
  float: left;
  position: relative;
  margin-top: 5px;
  margin-right: 9px;
  margin-bottom: 9px;
  width: 77px;
  height: 77px;
  border: 1px dashed #d9d9d9;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
}
.weui-uploader__input-box .iconfont {
  font-size: 30px;
}
.weui-uploader__input {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.weui-uploader__img {
  display: block;
  width: 79px;
  height: 79px;
  overflow: hidden;
}
.weui-uploader__file {
  position: relative;
  float: left;
  margin-top: 5px;
  margin-right: 12px;
  margin-bottom: 12px;
  width: 79px;
  height: 79px;
  background: no-repeat center center;
  background-size: cover;
}
.weui-uploader__file .imgclose {
  position: absolute;
  top: -4px;
  right: -4px;
  color: #333;
  font-size: 18px;
}
.weui-uploader__file_status {
  position: relative;
  display: block;
}
.weui-uploader__file_status:before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.weui-uploader__file-content {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
}
</style>
